(function () {




    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    document.querySelectorAll('p').forEach(e => {
        if (e.innerHTML.trim() === '') e.remove();
    });

    $('.sym-slides').slick();

    $('.slider-3-items__slider').slick({
        infinite: true,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 7000,
        speed: 500,
        fade: false,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 780,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.room-img__slider').slick({
        infinite: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 7000,
        speed: 500,
        fade: false,
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 780,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    });

    $('.capacity-item__button').click(function () {
        if ($(this).siblings('.capacity-item__content').is(':hidden')) {
            $('.capacity-item__content').slideUp();
            $(this).siblings('.capacity-item__content').slideDown(400);
            $(this).addClass('open');
            $(this).find('span').text('View less');
        } else {
            $(this).siblings('.capacity-item__content').slideUp(400);
            $(this).removeClass('open');
            $(this).find('span').text('View details');
        }
    });


    function scrollDown() {
        let valScroll = $(window).scrollTop();
        if (valScroll > 50) {
            $('#header').addClass('scroll');
        } else {
            $('#header').removeClass('scroll');
        }
    }

    //Acts when scroll down page.
    $(window).scroll(function (event) {
        scrollDown();
    });

}());